(function () {
  'use strict';

  var cfg = window.ZeniqasEmailMarketing || {};

  function subscribeKlaviyo(email, properties) {
    if (!email || typeof window._learnq === 'undefined') return;
    window._learnq.push(['identify', Object.assign({ $email: email }, properties || {})]);
    if (cfg.klaviyoListId) {
      window._learnq.push(['track', 'Subscribed to List', {
        ListID: cfg.klaviyoListId,
        Email: email
      }]);
    }
  }

  function backInStockKlaviyo(email, el) {
    if (!email || typeof window._learnq === 'undefined') return;
    var payload = {
      $email: email,
      ProductID: el.dataset.productId,
      VariantID: el.dataset.variantId,
      ProductHandle: el.dataset.productHandle
    };
    window._learnq.push(['track', 'Back in Stock', payload]);
    subscribeKlaviyo(email, payload);
  }

  function updateBackInStockVariant(event) {
    var bis = document.querySelector('.zeniqas-back-in-stock');
    if (!bis || !event || !event.data || !event.data.variant) return;
    bis.dataset.variantId = event.data.variant.id;
    bis.hidden = !!event.data.variant.available;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('zeniqas-newsletter-form')) return;
    var emailInput = form.querySelector('input[type="email"][name="contact[email]"]');
    if (!emailInput || !emailInput.value) return;
    var email = emailInput.value.trim();
    var bis = form.closest('.zeniqas-back-in-stock');
    if (bis) {
      backInStockKlaviyo(email, bis);
      return;
    }
    subscribeKlaviyo(email, { source: form.id || 'newsletter' });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, updateBackInStockVariant);
  }
})();
